import { StrictMode } from "react"
import { createRoot } from "react-dom/client"
import { QueryClient, QueryClientProvider } from "@tanstack/react-query"
import { MsalProvider } from "@azure/msal-react"

import "./index.css"
import App from "./App.tsx"
import { ThemeProvider } from "@/components/theme-provider.tsx"
import { msalInstance } from "@/lib/auth.ts"

const queryClient = new QueryClient({
  defaultOptions: { queries: { retry: 1, staleTime: 5_000 } },
})

// msal-browser v4 requires initialize() to be awaited before any other MSAL
// API call (loginRedirect, acquireTokenSilent, useMsal internals, etc.).
await msalInstance.initialize()

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <MsalProvider instance={msalInstance}>
      <ThemeProvider>
        <QueryClientProvider client={queryClient}>
          <App />
        </QueryClientProvider>
      </ThemeProvider>
    </MsalProvider>
  </StrictMode>
)
